
export type TweetResponseStats = {
  likes?: number;
  replies?: number;
  retweets?: number;
  views?: number;
};
